import React from 'react'
import Param from '../store/param';
import FormSetup from './formSetup';

import FormAlignFinalDeviceFinalStep from './formAlignFinalDeviceFinalStep';
import FormHoleFinalDeviceFinalStep from './formHoleFinalDeviceFinalStep';

/**
 * Renders a form based on the active step stored in the Param store.
 * @returns {JSX.Element|string} The form component to render or 'Unknown step' if the active step is not recognized.
 */
const FormFinalDeviceFinalStep = () => {
  const activeStep = Param.Get('activeStep');

  switch (activeStep) {
    // case 0:
    //   return <FormSetup/>;
    case 0:
      return <FormAlignFinalDeviceFinalStep/>;
    case 1:
      return <FormHoleFinalDeviceFinalStep/>;
    default:
      return 'Unknown step';
  }
}

export default FormFinalDeviceFinalStep
